module.exports = __webpack_public_path__ + "5bde7a10f3421fd7e82426d5b5556348.MP3";